import styled, { css } from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors, spacing } = globalStyles;

export const List = styled.ul<{ maxWidth: number | undefined }>`
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  padding-left: ${spacing.space16};
  font-size: 1.125rem;

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth}px;
    `}
`;

export const Item = styled.li`
  position: relative;
  box-sizing: border-box;
  margin-bottom: ${spacing.space8};
  list-style: none;

  &:before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${colors.typography.black};
    position: absolute;
    top: 8px;
    left: calc(-${spacing.space16} - 1px);
  }

  &:last-child,
  &:only-child {
    margin-bottom: 0;
  }
`;
